<div class="sticky !bg-[#fff] top-0 !p-0">
  <div
    class="flex justify-between items-center !bg-[#dee2e6] p-4 !pl-[31px] !pr-[40px]"
  >
    <div class="flex justify-start items-center gap-8 !bg-[#dee2e6]">
      <h3 class="project-plan">Project Plan</h3>
      <span
        class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
        >Select Measurement Standard</span
      >
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="flex justify-end">
    <app-progress-bar
      [progress]="stage2Progress"
      [sectionId]="'section2'"
      [selectedSection]="selectedSection"
      [sectionName]="'Project Plan'"
    >
    </app-progress-bar>
  </div>
</div>
<div class="content">
  <div class="package-title">
    <!-- Work Packages -->
    <measurement-standards
      (valueSelected)="updateSelectedWPStandard($event)"
      (valueSubSelected)="updateSubCategorySelectedValue($event)"
      [selectedCategory]="selectedParentWP"
    ></measurement-standards>
  </div>
  <div class="flex items-center justify-center mt-[2px] ml-5 mr-5">
    <div class="nrm-sections w-full md:w-1/2 lg:w-1/2 mr-[40px]">
      <div class="available_package flex">
        <div class="items-center justify-center">
          {{ selectedParentWP?.name }} Work Packages
        </div>

        <div
          *ngIf="selectedParentWP?.name === 'CUSTOM'"
          class="flex !text-center ml-[54px] bg-white p-[4px] text-[#1A4971] w-[62px] height-[42px] justify-center items-center"
          style="
            font-size: 12.426px;
            font-weight: 500;
            cursor: pointer;
            border-radius: 3.306px;
            border: 1px solid #e76b3f;
            background: #f1f3f5;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
            color: #e76b3f;
          "
          (click)="addmore()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
          >
            <path
              d="M2.84712 0.589844V5.41055M0.436768 3.0002H5.25748"
              stroke="#1A4971"
              stroke-width="0.69005"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <button class="ml-[3px] mt-[3px]">Add</button>
        </div>
      </div>

      <!-- Work packages list panel -->
      <div class="packages-list" style="overflow-y: scroll">
        <div
          *ngFor="let parent of collectionL"
          class="flex flex-col justify-center !py-[0.25rem]"
        >
          <div
            class="flex mb-[3px] hover:bg-[#fae8e1]"
            (mouseenter)="hoveredParentId = parent.id"
            (mouseleave)="hoveredParentId = null"
          >
            <div class="flex justify-between items-center w-[100%]">
              <div class="flex ml-[10px] !h-[1.9375rem]">
                <span style="width: 30px">
                  <button
                    *ngIf="parent.children && parent.children.length > 0"
                    (click)="toggleExpand(parent.id!, 'L')"
                  >
                    <ng-container
                      *ngIf="isExpanded(parent.id!, 'L'); else collapsedIcon"
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.480797"
                          y="0.480797"
                          width="18.0384"
                          height="18.0384"
                          rx="5.28877"
                          fill="#F7FAFF"
                        />
                        <rect
                          x="0.480797"
                          y="0.480797"
                          width="18.0384"
                          height="18.0384"
                          rx="5.28877"
                          stroke="#21252A"
                          stroke-width="0.961594"
                        />
                        <path
                          d="M5.62109 9.5H13.3794"
                          stroke="#21252A"
                          stroke-width="1.92319"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </ng-container>
                    <ng-template #collapsedIcon>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.440943"
                          y="0.440943"
                          width="16.7558"
                          height="16.7558"
                          rx="4.85037"
                          fill="#F7FAFF"
                        />
                        <rect
                          x="0.440943"
                          y="0.440943"
                          width="16.7558"
                          height="16.7558"
                          rx="4.85037"
                          stroke="#343A40"
                          stroke-width="0.881885"
                        />
                        <g clip-path="url(#clip0_5715_48904)">
                          <path
                            d="M11.7365 9.20156H9.44374V11.4943H8.67949V9.20156H6.38672V8.4373H8.67949V6.14453H9.44374V8.4373H11.7365V9.20156Z"
                            fill="#343A40"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_5715_48904">
                            <rect
                              width="9.17108"
                              height="9.17108"
                              fill="white"
                              transform="translate(4.47656 4.23438)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </ng-template>
                  </button>
                </span>
                <p class="!mb-0">
                  <span *ngIf="parent.suffix" class="font-semibold">{{
                    parent.suffix + " "
                  }}</span>
                  {{ parent.name }}
                </p>
              </div>
            </div>

            <svg
              *ngIf="
                hoveredParentId === parent.id &&
                selectedParentWP?.name === 'Custom'
              "
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="delete (1) 1">
                <g id="Group">
                  <path
                    id="Vector"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99698 0.333164C7.99696 0.244887 7.96189 0.160229 7.89949 0.0977926C7.83708 0.0353562 7.75244 0.000249621 7.66416 0.0001875L4.33625 0C4.24795 0.000204702 4.16334 0.0354085 4.10095 0.0978951C4.03857 0.160382 4.0035 0.245054 4.00344 0.333352V1.15641H7.99698V0.333164ZM2.52524 11.5232C2.53372 11.653 2.59149 11.7746 2.68672 11.8632C2.78195 11.9518 2.90743 12.0006 3.03748 11.9997H9.00118C9.1312 11.9994 9.25627 11.9498 9.35128 11.8611C9.44629 11.7723 9.5042 11.6509 9.51338 11.5212L10.0237 4.05595H1.98057L2.52512 11.5231L2.52524 11.5232ZM1.19942 3.37983H10.8008V2.60639C10.8006 2.40126 10.7191 2.20457 10.5741 2.0595C10.429 1.91444 10.2324 1.83286 10.0272 1.83267L1.97307 1.83241C1.76796 1.83273 1.57134 1.91438 1.42635 2.05946C1.28136 2.20454 1.19983 2.40121 1.19963 2.60632V3.37976L1.19942 3.37983ZM7.54606 10.2201C7.54606 10.2645 7.53732 10.3084 7.52033 10.3494C7.50335 10.3904 7.47845 10.4277 7.44706 10.4591C7.41567 10.4905 7.37841 10.5154 7.3374 10.5324C7.29639 10.5494 7.25244 10.5581 7.20805 10.5581C7.16366 10.5581 7.1197 10.5494 7.07869 10.5324C7.03768 10.5154 7.00042 10.4905 6.96903 10.4591C6.93765 10.4277 6.91275 10.3904 6.89576 10.3494C6.87877 10.3084 6.87003 10.2645 6.87003 10.2201V5.47992C6.87074 5.39078 6.90665 5.30552 6.96992 5.24273C7.0332 5.17993 7.11872 5.14468 7.20787 5.14465C7.29702 5.14462 7.38257 5.17981 7.44589 5.24256C7.50921 5.30531 7.54517 5.39054 7.54595 5.47969V10.2201H7.54606ZM5.13434 10.2201C5.13434 10.3097 5.09873 10.3957 5.03533 10.4591C4.97193 10.5225 4.88594 10.5581 4.79628 10.5581C4.70662 10.5581 4.62063 10.5225 4.55724 10.4591C4.49384 10.3957 4.45822 10.3097 4.45822 10.2201V5.47992C4.45893 5.39076 4.49484 5.3055 4.55812 5.24269C4.62141 5.17989 4.70695 5.14463 4.79611 5.1446C4.88527 5.14457 4.97083 5.17977 5.03416 5.24253C5.09749 5.30529 5.13345 5.39053 5.13423 5.47969L5.13434 10.2201Z"
                    fill="#1A4971"
                  />
                </g>
              </g>
            </svg>
            <div
              *ngIf="hoveredParentId === parent.id"
              (click)="moveParentToCollectionR(parent.id)"
              class="arrow-btn1 items-center justify-center p-2 hover:bg-gray-300 hover:rounded-full group"
            >
              <!-- *ngIf="hoveredParentId === parent.id" will show the right arrow icon only on hovered item -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 6 8"
                fill="none"
                class="group-hover:scale-110 transition-transform duration-150"
              >
                <path
                  d="M5.22076 3.68784L1.66066 0.127804C1.57832 0.045398 1.4684 0 1.3512 0C1.23399 0 1.12408 0.045398 1.04174 0.127804L0.779558 0.389915C0.608958 0.560711 0.608958 0.838302 0.779558 1.00884L3.76906 3.99834L0.776241 6.99116C0.693901 7.07357 0.648438 7.18342 0.648438 7.30056C0.648438 7.41782 0.693901 7.52768 0.776241 7.61015L1.03842 7.8722C1.12082 7.9546 1.23068 8 1.34788 8C1.46508 8 1.575 7.9546 1.65734 7.8722L5.22076 4.30891C5.30329 4.22624 5.34863 4.11587 5.34837 3.99854C5.34863 3.88075 5.30329 3.77044 5.22076 3.68784Z"
                  fill="#2A2C2E"
                />
              </svg>
            </div>
          </div>
          <div
            class="w-full mb-2"
            *ngIf="
              parent.children &&
              parent.children.length > 0 &&
              isExpanded(parent.id!, 'L')
            "
          >
            <div
              *ngFor="let childPackage of parent.children"
              class="bg-[#FFF] hover:bg-[#fae8e1] ms-4 child-row !pl-[60px]"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0px !important;
              "
              (mouseenter)="hoveredChildId = childPackage.id"
              (mouseleave)="hoveredChildId = null"
            >
              <p class="ml-[20px] !my-2">
                <span *ngIf="childPackage.suffix" class="font-semibold">{{
                  childPackage.suffix + " "
                }}</span>
                {{ childPackage.name }}
              </p>
              <div
                *ngIf="hoveredChildId === childPackage.id"
                (click)="moveChildToCollectionR(parent.id, childPackage.id)"
                class="arrow-btn1 inline-flex items-center justify-center p-2 hover:bg-gray-300 hover:rounded-full group"
              >
                <!-- *ngIf="hoveredParentId === parent.id" will show the right arrow icon only on hovered item -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 6 8"
                  fill="none"
                  class="group-hover:scale-110 transition-transform duration-150"
                >
                  <path
                    d="M5.22076 3.68784L1.66066 0.127804C1.57832 0.045398 1.4684 0 1.3512 0C1.23399 0 1.12408 0.045398 1.04174 0.127804L0.779558 0.389915C0.608958 0.560711 0.608958 0.838302 0.779558 1.00884L3.76906 3.99834L0.776241 6.99116C0.693901 7.07357 0.648438 7.18342 0.648438 7.30056C0.648438 7.41782 0.693901 7.52768 0.776241 7.61015L1.03842 7.8722C1.12082 7.9546 1.23068 8 1.34788 8C1.46508 8 1.575 7.9546 1.65734 7.8722L5.22076 4.30891C5.30329 4.22624 5.34863 4.11587 5.34837 3.99854C5.34863 3.88075 5.30329 3.77044 5.22076 3.68784Z"
                    fill="#2A2C2E"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- selected work packages panel -->
    <div class="nrm-sections w-full md:w-1/2 lg:w-1/2 flex flex-col">
      <div class="available_package">Selected Work Packages</div>
      <div class="packages-list">
        <div *ngFor="let parent of collectionR">
          <div
            class="flex justify-left items-center hover:bg-[#fae8e1]"
            (mouseenter)="hoveredSelectedId = parent.id"
            (mouseleave)="hoveredSelectedId = null"
          >
            <div
              (click)="moveParentToCollectionL(parent.id)"
              class="arrow-btn1 ml-[10px] relative inline-flex items-center justify-center p-2 hover:bg-gray-300 hover:rounded-full group transition-opacity duration-150"
              [ngClass]="{
                'opacity-0 invisible': hoveredSelectedId !== parent.id,
                'opacity-100 visible': hoveredSelectedId === parent.id
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 6 8"
                fill="none"
                class="group-hover:scale(-1, 1) transition-transform duration-150"
                transform="scale(-1, 1)"
              >
                <path
                  d="M5.22076 3.68784L1.66066 0.127804C1.57832 0.045398 1.4684 0 1.3512 0C1.23399 0 1.12408 0.045398 1.04174 0.127804L0.779558 0.389915C0.608958 0.560711 0.608958 0.838302 0.779558 1.00884L3.76906 3.99834L0.776241 6.99116C0.693901 7.07357 0.648438 7.18342 0.648438 7.30056C0.648438 7.41782 0.693901 7.52768 0.776241 7.61015L1.03842 7.8722C1.12082 7.9546 1.23068 8 1.34788 8C1.46508 8 1.575 7.9546 1.65734 7.8722L5.22076 4.30891C5.30329 4.22624 5.34863 4.11587 5.34837 3.99854C5.34863 3.88075 5.30329 3.77044 5.22076 3.68784Z"
                  fill="#2A2C2E"
                />
              </svg>
            </div>
            <div class="flex">
              <span style="width: 30px">
                <button
                  *ngIf="parent.children && parent.children.length > 0"
                  (click)="toggleExpand(parent.id!, 'R')"
                >
                  <ng-container
                    *ngIf="isExpanded(parent.id!, 'R'); else collapsedIcon"
                  >
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.480797"
                        y="0.480797"
                        width="18.0384"
                        height="18.0384"
                        rx="5.28877"
                        fill="#F7FAFF"
                      />
                      <rect
                        x="0.480797"
                        y="0.480797"
                        width="18.0384"
                        height="18.0384"
                        rx="5.28877"
                        stroke="#21252A"
                        stroke-width="0.961594"
                      />
                      <path
                        d="M5.62109 9.5H13.3794"
                        stroke="#21252A"
                        stroke-width="1.92319"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </ng-container>
                  <ng-template #collapsedIcon>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.440943"
                        y="0.440943"
                        width="16.7558"
                        height="16.7558"
                        rx="4.85037"
                        fill="#F7FAFF"
                      />
                      <rect
                        x="0.440943"
                        y="0.440943"
                        width="16.7558"
                        height="16.7558"
                        rx="4.85037"
                        stroke="#343A40"
                        stroke-width="0.881885"
                      />
                      <g clip-path="url(#clip0_5715_48904)">
                        <path
                          d="M11.7365 9.20156H9.44374V11.4943H8.67949V9.20156H6.38672V8.4373H8.67949V6.14453H9.44374V8.4373H11.7365V9.20156Z"
                          fill="#343A40"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_5715_48904">
                          <rect
                            width="9.17108"
                            height="9.17108"
                            fill="white"
                            transform="translate(4.47656 4.23438)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </ng-template>
                </button>
              </span>
              <p class="font-normal text-left" style="margin: 0px !important">
                <span *ngIf="parent.suffix" class="font-semibold">{{
                  parent.suffix + " "
                }}</span>
                {{ parent.name }}
              </p>
            </div>
          </div>
          <div
            class="mt-[7px]"
            *ngIf="
              parent.children &&
              parent.children.length > 0 &&
              isExpanded(parent.id!, 'R')
            "
          >
            <div
              class="child-container bg-[#FFF] hover:bg-[#fae8e1]"
              style="display: flex; align-items: center"
              *ngFor="let child of parent.children"
              (mouseenter)="hoveredChildId = child.id"
              (mouseleave)="hoveredChildId = null"
            >
              <div
                (click)="moveChildToCollectionL(parent.id, child.id)"
                class="arrow-btn1 relative inline-flex items-center justify-center p-2 hover:bg-gray-300 hover:rounded-full group transition-opacity duration-150"
                [ngClass]="{
                  'opacity-0 invisible': hoveredChildId !== child.id,
                  'opacity-100 visible': hoveredChildId === child.id
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 6 8"
                  fill="none"
                  class="group-hover:scale(-1, 1) transition-transform duration-150"
                  transform="scale(-1, 1)"
                >
                  <path
                    d="M5.22076 3.68784L1.66066 0.127804C1.57832 0.045398 1.4684 0 1.3512 0C1.23399 0 1.12408 0.045398 1.04174 0.127804L0.779558 0.389915C0.608958 0.560711 0.608958 0.838302 0.779558 1.00884L3.76906 3.99834L0.776241 6.99116C0.693901 7.07357 0.648438 7.18342 0.648438 7.30056C0.648438 7.41782 0.693901 7.52768 0.776241 7.61015L1.03842 7.8722C1.12082 7.9546 1.23068 8 1.34788 8C1.46508 8 1.575 7.9546 1.65734 7.8722L5.22076 4.30891C5.30329 4.22624 5.34863 4.11587 5.34837 3.99854C5.34863 3.88075 5.30329 3.77044 5.22076 3.68784Z"
                    fill="#2A2C2E"
                  />
                </svg>
              </div>
              <p class="pl-[60px] !mb-0 text-left">
                <!-- TODO: there is no suffix in collectionR. fix it -->
                <span *ngIf="child.suffix" class="font-semibold">{{
                  child.suffix + " "
                }}</span>
                {{ child.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    [pageScroll]="'true'"
    [pageScrollTarget]="'#cost'"
    class="w-[100%] flex justify-end mb-[1rem] mt-[21px] sticky"
  >
    <button
      class="save-btn shadow-[0px_4px_4px_rgba(0,0,0,0.25)] !font-medium"
      type="button"
      (click)="saveAndNavigateCostEstimation('save')"
    >
      <ng-container *ngIf="isLoadingSave; else normalTextSave">
        <div class="spinner"></div>
      </ng-container>
      <ng-template #normalTextSave>Save</ng-template>
    </button>
    <button
      class="next-btn"
      type="button"
      (click)="saveAndNavigateCostEstimation('next')"
      [ngClass]="{ 'loading-btn': isLoadingNext }"
    >
      <ng-container *ngIf="isLoadingNext; else normalTextNext">
        <div class="spinner"></div>
      </ng-container>
      <ng-template #normalTextNext>Next</ng-template>
    </button>
  </div>
</div>
